:host {
  --nest-shell-panel-bg-color: #fff;
}
